<template>
  <div>
    <div class="step">
      <!-- 상단 페이지명, 스텝 -->
      <div class="top-wrap" flex fjb>
        <div class="step-title">
          {{ "본인 인증" }}
        </div>
        <div class="step-number" flex>
          <div class="number active">1</div>
          <div class="number active ml8">2</div>
          <div class="number ml8">3</div>
          <div class="number ml8">4</div>
        </div>
      </div>
      <!-- //상단 페이지명, 스텝 -->

      <!-- 컨텐츠 -->
      <div class="bottom-wrap">
        <!-- {{ convertBase64ToFile }} -->
        <div class="image-box ta-c">
          <p class="fs16 bold mt40">
            {{ "촬영한 신분증 정보를 확인해 주세요." }}
          </p>
          <p>{{ "신분증 정보와 다른 내용은 직접 수정해 주세요." }}</p>
          <img
            :src="`data:image/png;base64, ${this.step2data.cropImage}`"
            alt="신분증"
          />
          <button @click="toStep2">다시 촬영하기</button>
        </div>
        <div class="input-box mt30 mb30">
          <div class="item type">
            <p>{{ "제출하는 신분증" }}</p>
            <div class="authID input-box">
              <el-input
                type="text"
                v-model="step2data.formName"
                class="en-name"
                disabled
              />
            </div>
          </div>
          <div class="item name">
            <div class="authID input-box">
              <p>{{ "이름" }}</p>
              <el-input
                type="text"
                max-length="24"
                @input="checkName(data.name)"
                v-model="data.name"
                class="en-name"
                :class="{ wrongData: wrongName || data.name == '' }"
              />
            </div>
            <div
              v-if="notiCheckName || data.name == ''"
              class="sub keyColor mt4 fs10"
            >
              {{ "* 올바른 이름을 입력하세요." }}
            </div>
            <div v-if="wrongName" class="sub keyColor mt4 fs10">
              {{ "* 휴대폰 인증 정보와 다릅니다." }}
            </div>
          </div>
          <div class="item id-number">
            <p>{{ "주민등록번호" }}</p>
            <div class="authID input-box" flex fjb>
              <el-input
                type="number"
                v-model="data.birth"
                @input="ssnCheck(data.birth, data.inIdNum)"
                class="half en-name"
                :class="{ wrongData: wrongBirthDate || data.birth == '' }"
              />

              <el-input
                type="number"
                v-model="data.inIdNum"
                @input="ssnCheck(data.birth, data.inIdNum)"
                class="half en-name"
                :class="{ wrongData: wrongGender || data.inIdNum == '' }"
              />
              <!-- // 주민번호 유효성 검사 안내문구 -->
              <div>
                <div
                  v-if="wrongNumber || data.birth == '' || data.inIdNum == ''"
                  class="sub keyColor mt4 fs10"
                >
                  {{ "* 올바른 주민등록번호를 입력하세요." }}
                </div>
                <div
                  v-if="wrongBirthDate || wrongGender"
                  class="sub keyColor mt4 fs10"
                >
                  {{ "* 휴대폰 인증 정보와 다릅니다." }}
                </div>
              </div>
              <!-- // 주민번호 유효성 검사 안내문구 -->
            </div>
          </div>
          <div v-if="step2data.formCode == 'S01000001'">
            <div class="item issue-date">
              <p>{{ "발급일자" }}</p>
              <div class="authID input-box">
                <el-input
                  type="number"
                  v-model="step2data.issueDate"
                  @input="checkDate(step2data.issueDate)"
                  class="en-name"
                  :class="{ wrongData: step2data.issueDate == '' }"
                />
                <!-- // 발급일자 유효성 검사 안내문구 -->
                <div
                  v-if="notiIssueDate || step2data.issueDate == ''"
                  class="sub keyColor mt4 fs10"
                >
                  {{ "* 올바른 발급일자를 입력하세요." }}
                </div>
                <!-- // 발급일자 유효성 검사 안내문구 -->
              </div>
            </div>
          </div>
          <div
            v-else-if="step2data.formCode == 'S01000002'"
            class="item issue-date"
          >
            <div class="item serial-number">
              <p>{{ "면허번호" }}</p>
              <div class="authID input-box">
                <el-input
                  type="text"
                  maxlength="12"
                  v-model="step2data.driverLicenseNo"
                  @input="checkLicenseNo(step2data.driverLicenseNo)"
                  class="en-name"
                  :class="{
                    wrongData: step2data.driverLicenseNo == '' || notiLicenseNo,
                  }"
                />
                <!-- // 면허번호 유효성 검사 안내문구 -->
                <div
                  v-if="step2data.driverLicenseNo == '' || notiLicenseNo"
                  class="sub keyColor mt4 fs10"
                >
                  {{ "* 올바른 면허번호를 입력하세요." }}
                </div>
                <!-- // 면허번호 유효성 검사 안내문구 -->
              </div>
            </div>
            <div class="item serial-number">
              <p>{{ "식별번호" }}</p>
              <div class="authID input-box">
                <el-input
                  type="text"
                  maxlength="6"
                  v-model="step2data.serialNo"
                  @input="checkSerialNo(step2data.serialNo)"
                  class="en-name"
                  :class="{ wrongData: step2data.serialNo == '' }"
                />
                <!-- // 식별번호 유효성 검사 안내문구 -->
                <div
                  v-if="notiSerialNo || step2data.serialNo == ''"
                  class="sub keyColor mt4 fs10"
                >
                  {{ "* 올바른 식별번호를 입력하세요." }}
                </div>
                <!-- // 식별번호 유효성 검사 안내문구 -->
              </div>
            </div>
          </div>
        </div>

        <div class="bottom-button-wrap" flex fjb>
          <button disabled class="next-button pre">
            {{ "이전" }}
          </button>
          <button
            :disabled="
              wrongName ||
                wrongBirthDate ||
                wrongGender ||
                wrongNumber ||
                notiCheckName ||
                notiSerialNo ||
                notiLicenseNo ||
                notiIssueDate
            "
            @click="toStep3"
            class="next-button next"
          >
            {{ "진위 확인" }}
          </button>
        </div>
      </div>
      <!-- // 컨텐츠 -->
    </div>
  </div>
</template>

<script>
import Api from "@/common/Api.js";
import axios from "axios";

export default {
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.getOcrBirth = this.step2data.fullIdNum.slice(0, 6); // ocr data
    this.getOcrIdNum = this.step2data.fullIdNum.slice(6); // ocr data
    this.data.birth = this.getOcrBirth;
    this.data.inIdNum = this.getOcrIdNum;
    this.data.name = this.step2data.getOcrName;

    switch (this.data.inIdNum.slice(0, 1)) {
      case "1":
      case "3":
        this.data.gender = "M";
        break;

      case "2":
      case "4":
        this.data.gender = "F";
        break;

      default:
        break;
    }
    if (this.step2data.getOcrName !== this.step2data.getName) {
      this.wrongName = true;
    }
    if (this.getOcrBirth !== this.step2data.getBirthDate.slice(2)) {
      this.wrongBirthDate = true;
    }
    if (this.data.gender !== this.step2data.getGender) {
      this.wrongGender = true;
    }
    // 발급일자 8자리 체크
    if (this.step2data.issueDate.length > 8) {
      this.notiIssueDate = true;
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          birth: String,
          inIdNum: String,
        };
      },
    },
    step2data: {
      cropImage: String,
      formName: String,
      formCode: String,
      issueDate: String,
    },
  },
  data() {
    return {
      wrongName: false,
      wrongBirthDate: false,
      wrongGender: false,
      wrongNumber: false,
      notiCheckName: false,
      notiSerialNo: false,
      notiLicenseNo: false,
      notiIssueDate: false,
      gender: "",
      url: "",
      params: {},
    };
  },
  methods: {
    toStep2() {
      this.step2data.maskingImage = "";
      this.step2data.cropImage = "";
      this.step2data.formCode = "";
      this.step2data.formName = "";
      this.step2data.getOcrName = "";
      this.step2data.issueDate = "";
      this.step2data.driverLicenseNo = "";
      this.step2data.serialNo = "";
      this.$emit("tostep2");
    },
    async toStep3() {
      if (this.step2data.name !== this.step2data.getName) {
        this.wrongName = true;
        return;
      }
      this.wrongName = false;

      if (this.step2data.birth !== this.step2data.getBirthDate.slice(2)) {
        this.wrongBirthDate = true;
        return;
      }
      this.wrongBirthDate = false;
      switch (this.data.inIdNum.slice(0, 1)) {
        case "1":
        case "3":
          this.data.gender = "M";
          break;

        case "2":
        case "4":
          this.data.gender = "F";
          break;

        default:
          break;
      }
      if (this.data.gender !== this.step2data.getGender) {
        this.wrongGender = true;
        return;
      }
      this.wrongGender = false;

      try {
        const formCode = this.step2data.formCode; // 진위 타입

        // 주민등록증
        if (formCode == "S01000001") {
          this.params = {
            organization: "0002",
            identity: this.data.birth + this.data.inIdNum,
            issueDate: this.step2data.issueDate,
            userName: this.step2data.name,
          };
          this.url = this.$isDevServer
            ? "https://identify.dev.flybit.com/v1/kr/public/mw/identity-card/status"
            : "https://identify.flybit.com/v1/kr/public/mw/identity-card/status";
        }
        // 운전면허증
        else if (formCode == "S01000002") {
          const licenseNo01 = this.step2data.driverLicenseNo.slice(0, 2);
          const licenseNo02 = this.step2data.driverLicenseNo.slice(2, 4);
          const licenseNo03 = this.step2data.driverLicenseNo.slice(4, 10);
          const licenseNo04 = this.step2data.driverLicenseNo.slice(10);
          this.params = {
            organization: "0001",
            userName: this.step2data.name,
            birthDate: this.step2data.getBirthDate,
            licenseNo01: licenseNo01,
            licenseNo02: licenseNo02,
            licenseNo03: licenseNo03,
            licenseNo04: licenseNo04,
            serialNo: this.step2data.serialNo,
          };

          this.url = this.$isDevServer
            ? "https://identify.dev.flybit.com/v1/kr/public/ef/driver-license/status"
            : "https://identify.flybit.com/v1/kr/public/ef/driver-license/status";
        }

        const res = await axios.post(this.url, this.params, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });

        const resAuthenticity = res.data.result.resAuthenticity; // 진위 확인
        if (resAuthenticity !== "1") {
          this.$vs.notify({
            title: "안내",
            text: "입력 정보를 다시 확인하세요.",
            type: "danger",
            position: "top-left",
          });
          return;
        }
        this.$emit("tostep3");
      } catch (err) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: err.response.data.header.message,
          position: "top-right",
          color: "danger",
        });
        return;
      }
    },
    //주민등록번호 유효성 검사
    ssnCheck(_ssn1, _ssn2) {
      if (this.step2data.birth !== this.step2data.getBirthDate.slice(2)) {
        this.wrongBirthDate = true;
        return;
      }
      this.wrongBirthDate = false;
      switch (this.data.inIdNum.slice(0, 1)) {
        case "1":
        case "3":
          this.data.gender = "M";
          break;

        case "2":
        case "4":
          this.data.gender = "F";
          break;

        default:
          break;
      }

      if (this.data.gender !== this.step2data.getGender) {
        this.wrongGender = true;
        return;
      }
      this.wrongGender = false;

      if (this.data.birth !== "" && this.data.birth.length > 6) {
        this.data.birth = this.data.birth.slice(0, 6);
      }
      if (this.data.inIdNum !== "" && this.data.inIdNum.length > 7) {
        this.data.inIdNum = this.data.inIdNum.slice(0, 7);
      }

      const ssn1 = _ssn1;
      const ssn2 = _ssn2 || "";
      const ssn = ssn1 + ssn2;
      const arr_ssn = [];
      const compare = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
      // const checkSsn = /[^0-9]/;
      let sum = 0;

      // 공식: M = (11 - ((2×A + 3×B + 4×C + 5×D + 6×E + 7×F + 8×G + 9×H + 2×I + 3×J + 4×K + 5×L) % 11)) % 10
      for (let i = 0; i < 13; i++) {
        arr_ssn[i] = ssn.substring(i, i + 1);
      }

      for (let i = 0; i < 12; i++) {
        sum = sum + arr_ssn[i] * compare[i];
      }

      sum = (11 - (sum % 11)) % 10;

      if (sum != arr_ssn[12]) {
        this.wrongNumber = true;
        return;
      }

      // 생년월일 공백일 때
      if (ssn1 == "") {
        this.wrongNumber = true;
        return;
      }

      // 주민번호 뒷자리 공백일 때
      if (ssn2 == "") {
        this.wrongNumber = true;
        return;
      }

      // 입력값 체크
      if (ssn1.match("[^0-9]")) {
        this.wrongNumber = true;
        return;
      }

      // 입력값 체크
      if (ssn2.match("[^0-9]")) {
        this.wrongNumber = true;
        return;
      }

      // 자리수 체크
      if (ssn.length != 13) {
        this.wrongNumber = true;
        return;
      }

      this.wrongNumber = false;
      return "";
    },
    // 이름 유효성 검사
    checkName(name) {
      if (this.step2data.name !== this.step2data.getName) {
        this.wrongName = true;
        return;
      }
      this.wrongName = false;

      const checkName = /^[a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣]*$/;
      if (name.length > 0 && checkName.test(name)) {
        this.notiCheckName = false;
      } else {
        this.notiCheckName = true;
      }
    },
    // 면허번호 유효성 검사
    checkLicenseNo(number) {
      if (this.step2data.driverLicenseNo.length == 12) {
        this.notiLicenseNo = false;
      } else {
        this.notiLicenseNo = true;
      }
      this.step2data.driverLicenseNo = number.slice(0, 12);
    },
    // 발급일자 유효성 검사
    checkDate(number) {
      const checkItem = /^[0-9]*$/;
      if (number.length > 0 && checkItem.test(number)) {
        this.notiIssueDate = false;
      } else {
        this.notiIssueDate = true;
      }
      this.step2data.issueDate = this.step2data.issueDate.slice(0, 8);
    },
    // 식별번호 유효성 검사
    checkSerialNo(number) {
      const serialNumber = number.toUpperCase();
      const checkItem = /^[A-Z0-9]*$/;
      if (serialNumber.length > 0 && checkItem.test(serialNumber)) {
        this.notiSerialNo = false;
      } else {
        this.notiSerialNo = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// step number
.step-number {
  .number {
    width: 20px;
    height: 20px;
    text-align: center;
    color: #dcdfe3;
    border-radius: 2px;
    background-color: #f7f8fa;
    &.active {
      color: #fff;
      background-color: #333;
    }
  }
}
.bottom-wrap {
  position: relative;
  .image-box {
    img {
      display: flex;
      width: 80%;
      margin: 20px auto 0;
    }
    button {
      margin-top: 10px;
      padding: 10px;
      background-color: #00b473;
    }
  }
  .input-box {
    .item {
      margin-top: 20px;
      .input-box {
        .half {
          width: calc((100% - 12px) / 2);
        }
      }
    }
  }
}
// 하단 버튼
button.next-button {
  width: 100%;
  padding: 9px 0;
  /* font-size: 12px; */
  border-radius: 2px;
  border: 1px solid #00b473;
  background-color: #00b473;
  &.pre {
    width: 96px;
    color: #333;
    border: 1px solid #eeeeee;
    background-color: #fff;
    &:disabled {
      border: solid 1px #dadada !important;
      background-color: #dadada !important;
    }
  }
  &.next {
    width: calc(100% - 104px);
    &.red {
      border-color: #eb3264;
      background-color: #eb3264;
    }
  }
  &.bottom {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 24px);
  }
  &:disabled {
    border: solid 1px #dadada !important;
    background-color: #dadada !important;
  }
}
.bottom-button-wrap {
  width: 100%;
}
</style>
